import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";

// Components
import Tags from "../Tags";
import Author from "./Author";
import Social from "../Social";

// Style
import * as S from "./style";
import { RouterState } from "../Grid";
import { FilterButton } from "../FilterBar/style";

interface ArticleCardProps {
  isMain?: boolean;
  isOneArticle?: boolean;
  isSecondary?: boolean;
  id: string;
  title: string;
  description?: string;
  image?: any;
  image_caption?: string;
  created?: string;
  effective: string;
  creators: string[];
  subjects: string[];
  parent: {
    title: string;
  };
  text: {
    data: string;
  };
  theme?: string;
  onFilterByTheme?: (theme: string) => void;
}

const ArticleCard: React.FC<ArticleCardProps> = ({
  isMain,
  isOneArticle,
  id,
  title,
  description,
  text,
  image,
  image_caption,
  created,
  subjects,
  parent,
  creators,
  effective,
  theme,
}) => {
  const date = moment(effective).format("DD/MM/YYYY");

  const location = useLocation<RouterState>();



  return (
    <>
      {!location.pathname.includes("/case-study") ? (

        <S.ArticleCard
          isOneArticle={isOneArticle}
          className={isMain ? "card card__main" : "card card__secondary"}>
          {image && (
            <div className="card__image">
              <img src={image.scales.large.download} alt={image_caption} />
            </div>
          )}
          {isMain ? (
            <div className="card__info main">
              <div className="social">
                <Social id={id} title={title} subjects={subjects} parent={parent} />
              </div>
              <div className="info">
                <div className="date">{date}</div>
                <div className="read-time">
                  {text && Math.ceil(text.data.split(" ").length / 200)} min di
                  lettura
                </div>
              </div>
            </div>
          ) : (
            <div className="card__info secondary">
              <div className="date">{date}</div>
              <div className="read-time">
                {text && Math.ceil(text.data.split(" ").length / 200)} min di
                lettura
              </div>
            </div>
          )}
          <Link to={`/${parent.title.toLowerCase().replace(" ", "-")}/${id}`}>
            {isMain ? (
              <h1 className="card__title">{title}</h1>
            ) : (
              <h3 className="card__title">{title}</h3>
            )}
          </Link>
          {creators.map((creator) => (
            <Author key={creator} creator={creator} />
          ))}
          {description && (
            <p>
              {description.length > 150
                ? `${description.replace(/^(.{150}[^\s]*).*/, "$1")}...`
                : description}
            </p>
          )}
        </S.ArticleCard>
      ) : (
        <S.ArticleCard
          isOneArticle={isOneArticle}
          className="card card__main"
        >
          <div className="card__image">
            <img src={image.scales.large.download} alt={image_caption} />
          </div>
          <div className="card__info main">
            <div className="social">
              <Social id={id} title={title} subjects={subjects} parent={parent} />
            </div>
            <div className="info">
              <div className="date">{date}</div>
              <div className="read-time">
                {text && Math.ceil(text.data.split(" ").length / 200)} min di
                lettura
              </div>
            </div>
          </div>


          <Link to={`/${parent.title.toLowerCase().replace(" ", "-")}/${id}`}>
            <h1 className="card__title" style={{marginBottom: "10px"}}>{title}</h1>
          </Link>
          <Tags parent={parent} subjects={subjects} theme={theme}/>
          {description && (
            <p style={{marginTop: "10px"}}>
              {description.length > 150
                ? `${description.replace(/^(.{150}[^\s]*).*/, "$1")}...`
                : description}
            </p>
          )}
          {creators.map((creator) => (
            <Author key={creator} creator={creator} />
          ))}
        </S.ArticleCard>


      )}

    </>
  );
};

export default ArticleCard;
